import gql from 'graphql-tag'
import client from '@stores/apollo'
import { Role } from '@api'
import handleFetchResult from '@utils/handleFetchResult'

export interface BatchUpdateRoleInput {
  ids: string[]
  role: Role
}

interface IPayload {
  changeRoleToEmployees: { employees: { id: string }[] }
}

const mutation = gql`
  mutation UpdateRole($input: ChangeRoleToEmployeesInput!) {
    changeRoleToEmployees(input: $input) {
      employees {
        id
      }
    }
  }
`

const mutateHandler = handleFetchResult<IPayload, Array<{ id: string }>>({
  handler: (data) => data.changeRoleToEmployees.employees,
  name: 'Contract',
})

export default function batchUpdateRole(
  input: BatchUpdateRoleInput
): Promise<Array<{ id: string }>> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}
